import { createContext } from 'react';
const DireccionContext = createContext(); 

export default DireccionContext;